import { render, staticRenderFns } from "./OrderExportsIndex.vue?vue&type=template&id=0ebbf4b4"
import script from "./OrderExportsIndex.vue?vue&type=script&lang=js"
export * from "./OrderExportsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports